/**
 * Include your custom JavaScript here.
 *
 * BUG.md E13 / PageFly-Exit S7 (2026-08-17): diese Datei war mit rund 40 Aufrufen der mit
 * Abstand groesste jQuery-Konsument des Themes - und sie fehlte in der S7-Aufgabenliste,
 * die nur die fuenf Liquid-Sections nannte. Sie ist jetzt jQuery-frei.
 *
 * Zwei Dinge, die beim Lesen sofort auffallen und Absicht sind:
 *
 * 1. Die Datei laeuft jetzt auch auf password.liquid und gift_card.liquid wirklich durch.
 *    Vorher hat der jQuery-Poll dort nach 5 s aufgegeben (BUG.md E9) und der ganze Rumpf
 *    wurde nie ausgefuehrt. Deshalb ist ab hier JEDER DOM-Zugriff einzeln geguarded -
 *    auf diesen beiden Layouts existiert keines der gesuchten Elemente.
 *
 * 2. bhSetVisible() ist kein Einzeiler. jQuerys .show() stellt den vorherigen display-Wert
 *    wieder her bzw. faellt auf den Default des Tags zurueck, wenn das display:none aus
 *    einem Stylesheet kommt. Genau dieser zweite Fall liegt hier vor: die Versandzeilen
 *    .free und .paid sind in assets/custom.css:1836 per Regel ausgeblendet. Ein blosses
 *    style.display = "" haette sie nie wieder sichtbar gemacht.
 *    src/theme.js hat dieselben zwei Funktionen noch einmal - die beiden Dateien teilen
 *    keinen Modulraum. Wer hier etwas aendert, aendert es dort mit.
 */

// -----------------------------------------------------------
// 1. ZENTRALER SPEICHER (State)
// -----------------------------------------------------------
window.CustomState = {
    price: 0,          // Verkaufspreis (Cents)
    compare: 0,        // UVP / Streichpreis (Cents)
    qty: 1,            // Gewählte Menge
    symbol: '£'        // Währungssymbol
};

// -----------------------------------------------------------
// 1a. VANILLA-HELFER (Ersatz genau der jQuery-Aufrufe, die hier standen)
// -----------------------------------------------------------
var DEFAULT_DISPLAY_BY_TAG = {
    A: 'inline',
    SPAN: 'inline',
    EM: 'inline',
    STRONG: 'inline',
    LABEL: 'inline',
    LI: 'list-item',
    TABLE: 'table',
    TR: 'table-row',
    TD: 'table-cell',
    TH: 'table-cell'
};

function bhAll(selector) {
    return document.querySelectorAll(selector);
}

function bhOne(selector) {
    return document.querySelector(selector);
}

// jQuery .text() haengt den Text ALLER Treffer aneinander, nicht nur des ersten.
// An einer Stelle unten haengt genau daran die Streichpreis-Erkennung.
function bhText(selector) {
    var nodes = bhAll(selector);
    var out = '';
    for (var i = 0; i < nodes.length; i++) {
        out += nodes[i].textContent;
    }
    return out;
}

// Ersatz fuer $(sel).not(a).not(b).first()
function bhFirstNotMatching(selector, excluded) {
    var nodes = bhAll(selector);
    for (var i = 0; i < nodes.length; i++) {
        if (!nodes[i].matches(excluded)) {
            return nodes[i];
        }
    }
    return null;
}

function bhSetElementVisible(element, visible) {
    if (!element) {
        return;
    }
    if (!visible) {
        element.style.display = 'none';
        return;
    }
    element.style.display = '';
    if (window.getComputedStyle(element).display === 'none') {
        element.style.display = DEFAULT_DISPLAY_BY_TAG[element.tagName] || 'block';
    }
}

function bhSetNodesVisible(nodes, visible) {
    if (!nodes) {
        return;
    }
    for (var i = 0; i < nodes.length; i++) {
        bhSetElementVisible(nodes[i], visible);
    }
}

function bhSetVisible(selector, visible) {
    bhSetNodesVisible(bhAll(selector), visible);
}

function bhRemoveAll(selector) {
    var nodes = bhAll(selector);
    for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].parentNode) {
            nodes[i].parentNode.removeChild(nodes[i]);
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {

    try { if (typeof ratingSnippet === 'undefined') window.ratingSnippet = function() {}; } catch (e) {}

    // -----------------------------------------------------------
    // 2. HELPER & ICON
    // -----------------------------------------------------------
    var initialText = bhText(".ProductMeta__PriceList");
    if (initialText.indexOf("€") > -1) window.CustomState.symbol = "&euro;";
    if (initialText.indexOf("$") > -1) window.CustomState.symbol = "$";

    function formatMoney(cents) {
        return window.CustomState.symbol + (cents / 100).toFixed(2);
    }

    // BUG.md E16/B19: Klassen-Hook statt fester ID - die ID in product-meta.liquid ist
    // jetzt section-scoped, damit Featured Product keine Doppel-IDs mehr erzeugt.
    var saleIconElement = bhOne(".js-sale-icon-source");
    var saleIconSource = saleIconElement ? saleIconElement.innerHTML : null;
    var fallbackIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" style="width: 12px; height: 12px;"><path d="M345 39.1L472.8 168.4c48 48 48 126.4 0 174.4L345 472.9c-29.4 29.4-71.8 39.8-109.9 26.9s-63.5-49.4-63.5-89V160c0-35.3-28.7-64-64-64H16c-8.8 0-16-7.2-16-16V34.9c0-19 21.6-30 36.6-19.6l60.7 42L158 15.4c15-10.4 36.6 .6 36.6 19.6V80h60.4c41.3 0 78.4-22.3 97.5-58.6C361.3 5.4 338.4 4.5 323.8 19.1l-66.2 67.5c-7 7.2-6.3 18.7 .9 25.1c6.9 6.2 17.6 5.8 24.3-1L345 39.1zM32 304c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"/></svg>';
    var saleIcon = (saleIconSource && saleIconSource.trim() !== "") ? saleIconSource : fallbackIcon;


// -----------------------------------------------------------
    // 3. RENDER FUNKTION (UI Bauen)
    // -----------------------------------------------------------
    window.renderCustomUI = function() {
        var state = window.CustomState;
        var i;

        // Wenn keine Preise da sind, können wir nichts tun
        if (!state.price || state.price === 0) return;

        // --- BERECHNUNG ---
        // Mengenstaffel 9 % / 12 % = die Discount-Kit-Functions BULK-DISCOUNT_* (Product volume,
        // je Einzelprodukt-ID). Auf Bundles greift keine davon: 2 Sets im Warenkorb ergeben
        // total_discount 0, 2 einzelne Brotdosen "Save 9%" (gemessen 08.09.2026 ueber /cart.js).
        // Die Anzeige rechnete die Staffel trotzdem fuer jedes Produkt, also zeigte die Set-Seite
        // bei Menge 2 einen Preis, den die Kasse nie gewaehrt. Nils: Sets sind schon rabattiert.
        // Erkennung ueber data-bh-product-type am Section-Root (sections/main-product.liquid),
        // Rueckfalloption das Bundle-Mengenfeld (seit 08.09.2026 ein Stepper mit derselben ID),
        // das nur Bundle-Templates rendern.
        var isBundlePage = !!document.querySelector('[data-bh-product-type="Bundle"]') ||
                           !!document.getElementById('quantityCustomSelectorBundle');
        var discount = 0;
        if (!isBundlePage) {
            if (state.qty == 2) discount = 0.09;
            else if (state.qty >= 3) discount = 0.12;
        }

        var currentPriceCents = Math.ceil(state.price * (1 - discount));

        // Soll Sale-Optik an sein? (Mengenstaffel ODER Streichpreis)
        var isSaleMode = (discount > 0) || (state.compare > state.price);

        // Badge Prozent Berechnung: Staffel, sonst Streichpreis-Prozent (bei Bundles also
        // auch bei Menge 2/3 weiter die -15 %)
        var badgePercent = 0;
        if (discount > 0) {
            badgePercent = Math.round(discount * 100);
        } else if (state.compare > state.price) {
            badgePercent = Math.round(((state.compare - state.price) * 100) / state.compare);
        }


        // --- DOM ELEMENTE FINDEN ---
        // Suche den Hauptpreis (der NICHT durchgestrichen ist)
        var mainPriceEl = bhFirstNotMatching(".ProductMeta__PriceList .Price", "s, .Price--compareAt, .compare-price-value");
        // Suche den Sticky Price
        var stickyPriceEl = document.getElementById("mobileStickyVariantPrice");


        // 1. Hauptpreis setzen & Färben
        var displayPrice = formatMoney(discount > 0 ? currentPriceCents : state.price);

        // Update Hauptpreis
        if (mainPriceEl) {
            mainPriceEl.innerHTML = displayPrice;
            if (mainPriceEl.getAttribute("id") !== "price-adjusted") mainPriceEl.setAttribute("id", "price-adjusted");
        }

        // Update Sticky Preis (Das fehlte vorher!)
        if (stickyPriceEl) {
            stickyPriceEl.innerHTML = displayPrice;
        }

        // Farbe setzen (für beide)
        if (isSaleMode) {
            var styleOrange = "color: #f24a00 !important;";
            if (mainPriceEl) mainPriceEl.setAttribute("style", styleOrange);
            if (stickyPriceEl) stickyPriceEl.setAttribute("style", styleOrange);
        } else {
            if (mainPriceEl) mainPriceEl.removeAttribute("style");
            if (stickyPriceEl) stickyPriceEl.removeAttribute("style");
        }


        // 2. Badge (Oben)
        if (badgePercent > 0) {
            var badgeHtml = '<div class="sale-badge-container" id="mengenrabatt-badge">' +
                            '<div class="sale-badge">' + saleIcon +
                               '<span id="badge-percent">-' + badgePercent + '%</span>' +
                            '</div></div>';

            if (!document.getElementById("mengenrabatt-badge")) {
                var priceLists = bhAll(".ProductMeta__PriceList");
                for (i = 0; i < priceLists.length; i++) {
                    priceLists[i].insertAdjacentHTML("afterbegin", badgeHtml);
                }
            } else {
                var percentNodes = bhAll("#badge-percent");
                for (i = 0; i < percentNodes.length; i++) {
                    percentNodes[i].textContent = '-' + badgePercent + '%';
                }
            }
        } else {
            bhRemoveAll("#mengenrabatt-badge");
        }


        // 3. Statt-Preis (Unten)
        // Wir verstecken ALLES was vom Theme kommt und bauen unser eigenes
        bhSetVisible(".Sparen_Preis", false);
        bhSetVisible(".js-base-price-sale", false);

        if (isSaleMode) {
            var strikePrice = formatMoney(state.compare);

            // Das HTML für unseren schönen Statt-Preis
            // 09.09.2026 (Nils): Farbe des Streichpreises kommt aus custom.css (17 px, #555);
            // das fruehere Inline-!important liess sich per Stylesheet nicht uebersteuern.
            // Nils, 08.09.2026 abends: Label und Streichpreis als ein Paar (.compare-price-pair),
            // damit "List Price:" nie allein umbricht; die Zeile bleibt einzeilig, nur der
            // Sparbetrag darf auf schmalen Breiten darunter rutschen (assets/custom.css).
            var innerHTML = '<span class="compare-price-pair">' +
                            '<span class="compare-price-text" style="color: #6a6a6a !important; font-weight: normal; font-size: 0.8em; margin-right: 5px;">List Price: </span>' +
                            '<s class="compare-price-value" style="text-decoration: line-through !important;">' + strikePrice + '</s>' +
                            '</span>';

            // Sparbetrag in Waehrung neben dem Streichpreis (08.09.2026, Set-Seiten). Pro Stueck:
            // bei Menge 1 die Differenz Streichpreis zu Preis (Bundle-Rabatt), bei Menge 2/3
            // die Differenz zum Mengenrabattpreis. Der Prozentwert steht weiter im Badge oben.
            var savingCents = state.compare - currentPriceCents;
            if (savingCents > 0) {
                innerHTML += '<span class="compare-price-saving">You save ' + formatMoney(savingCents) + '</span>';
            }

            // Container suchen oder erstellen
            var myContainer = document.getElementById("pricecontainermengenrabatt");

            if (!myContainer) {
                // Wenn noch nicht da -> Bauen (hinter den LETZTEN Preis-Container, wie .last().after())
                var containers = bhAll(".ProductMeta__PriceList .ProductMeta__Price__Container");
                if (containers.length > 0) {
                    var newContainer = '<div class="ProductMeta__Price__Container compareAt-mengenrabatt" id="pricecontainermengenrabatt">' + innerHTML + '</div>';
                    containers[containers.length - 1].insertAdjacentHTML("afterend", newContainer);
                }
            } else {
                // Wenn da -> Inhalt updaten
                myContainer.innerHTML = innerHTML;
            }

            // Verstecke normale Shopify Compare-Preise
            var compareNodes = bhAll(".ProductMeta__PriceList .Price--compareAt");
            for (i = 0; i < compareNodes.length; i++) {
                if (compareNodes[i].matches("#compareAtmengenrabatt, #pricecontainermengenrabatt s")) continue;
                bhSetElementVisible(compareNodes[i], false);
            }

        } else {
            // Kein Sale -> Container weg
            bhRemoveAll("#pricecontainermengenrabatt");
        }
    };


    // -----------------------------------------------------------
    // 4. DATEN LADEN
    // -----------------------------------------------------------
    function updatePricesFromDOM() {
        var rawPriceEl = bhOne("[data-raw-price]");
        var rawCompareEl = bhOne("s[data-raw-price], .Price--compareAt[data-raw-price]");
        var rawPrice = rawPriceEl ? rawPriceEl.getAttribute("data-raw-price") : null;
        var rawCompare = rawCompareEl ? rawCompareEl.getAttribute("data-raw-price") : null;

        if (rawPrice) window.CustomState.price = parseInt(rawPrice);
        if (rawCompare) window.CustomState.compare = parseInt(rawCompare);

        // Fallback
        if (!window.CustomState.price) {
            var priceEl = bhOne(".ProductMeta__PriceList .Price:not(s)");
            var priceTxt = priceEl ? priceEl.textContent.replace(/[^0-9\-\.]/g, "") : "";
            if(priceTxt) window.CustomState.price = Math.round(parseFloat(priceTxt) * 100);
        }

        if (!window.CustomState.compare) {
             // Absichtlich ueber ALLE Treffer, nicht nur den ersten - das war schon die
             // jQuery-Semantik von .text() und die Erkennung haengt daran.
             var cmpTxt = bhText(".ProductMeta__PriceList s, .js-base-price-sale").replace(/[^0-9\-\.]/g, "");
             if(cmpTxt) {
                 window.CustomState.compare = Math.round(parseFloat(cmpTxt) * 100);
             } else {
                 window.CustomState.compare = window.CustomState.price;
             }
        }

        if (window.CustomState.compare < window.CustomState.price) {
            window.CustomState.compare = window.CustomState.price;
        }

        window.renderCustomUI();
    }


    // -----------------------------------------------------------
    // 5. EVENT LISTENER
    // -----------------------------------------------------------
    function handleQtyChange(element, type) {
        // radio -> .custom-qty hell, .quantitySelect gedimmt; select -> umgekehrt
        bhToggleClass(".custom-qty", "dimmed", type !== 'radio');
        bhToggleClass(".quantitySelect", "dimmed", type === 'radio');

        var val = parseInt(element.value);
        window.CustomState.qty = val;
        window.renderCustomUI();
    }

    function bhToggleClass(selector, className, on) {
        var nodes = bhAll(selector);
        for (var i = 0; i < nodes.length; i++) {
            if (on) {
                nodes[i].classList.add(className);
            } else {
                nodes[i].classList.remove(className);
            }
        }
    }

    var quantityCustomSelector = document.getElementById("quantityCustomSelector");
    if (quantityCustomSelector) {
        quantityCustomSelector.addEventListener("change", function () { handleQtyChange(this, 'select'); });
    }

    // Die vier Ausloeser in sections/main-product.liquid und sections/sticky-add-to-cart.liquid
    // feuern seit S7 ein natives change-Event statt eines jQuery-Triggers. Ein jQuery-Trigger
    // haette diesen Listener hier NICHT mehr erreicht - deshalb gehoeren beide Aenderungen in
    // denselben Push.
    var qtyRadios = bhAll("input[name='qtyCtrl']");
    for (var r = 0; r < qtyRadios.length; r++) {
        qtyRadios[r].addEventListener("change", function () { handleQtyChange(this, 'radio'); });
    }

    var quantityCustomSelectorBundle = document.getElementById("quantityCustomSelectorBundle");
    if (quantityCustomSelectorBundle) {
        quantityCustomSelectorBundle.addEventListener("change", function () { handleQtyChange(this, 'select'); });
    }


    document.addEventListener("variant:changed", function (event) {
        // BUG.md E5: bei nicht verfuegbarer Variantenkombination kommt das Event ohne
        // detail bzw. ohne variant - der ungeschuetzte Zugriff warf einen TypeError.
        var variant = event.detail && event.detail.variant;
        if (variant) {
            window.CustomState.price = variant.price;
            window.CustomState.compare = variant.compare_at_price || variant.price;
            window.CustomState.qty = 1;

            if (quantityCustomSelector) quantityCustomSelector.selectedIndex = 0;
            // Set-Seiten (08.09.2026): #quantityCustomSelectorBundle ist ein Zahlenfeld (Stepper in
            // sections/main-product.liquid), kein Select mehr; selectedIndex = 0 waere wirkungslos.
            // Die gewaehlte Menge bleibt beim Variantenwechsel stehen (wie bei den Radios), also
            // den Zustand am Feld ausrichten. theme.js feuert 50 ms spaeter ohnehin ein change auf
            // dieses Feld und verteilt den Wert an alle Mengenfelder.
            if (quantityCustomSelectorBundle) {
                window.CustomState.qty = parseInt(quantityCustomSelectorBundle.value, 10) || 1;
            }

            setTimeout(window.renderCustomUI, 50);
        }
    });


    // -----------------------------------------------------------
    // 6. START (INITIAL LOAD)
    // -----------------------------------------------------------
    // BUG.md E6: frueher vier Durchlaeufe (sofort + 100/300/500 ms), jeder mit eigenem
    // Log. Preise und Mengenfelder werden serverseitig gerendert, ein Durchlauf genuegt;
    // spaetere DOM-Eingriffe faengt der MutationObserver ("WAECHTER") am Dateiende ab.
    //
    // Der Mehrfach-Selektor liefert den ersten Treffer in DOKUMENT-Reihenfolge, nicht in
    // Selektor-Reihenfolge - genau wie jQuerys .first(). Nicht in drei Abfragen aufteilen.
    var initialQtyInput = bhOne("#quantityCustomSelectorBundle, #quantityCustomSelector, input[name='qtyCtrl']:checked");
    if (initialQtyInput) {
        var initialQty = parseInt(initialQtyInput.value);
        if (initialQty > 0) window.CustomState.qty = initialQty;
    }

    updatePricesFromDOM();


    // -----------------------------------------------------------
    // 7. UTILS
    // -----------------------------------------------------------
    var freeShippingTextContainer = bhAll("body.template-product .Product__Info .items .item .free");
    var paidShippingTextContainer = bhAll("body.template-product .Product__Info .items .item .paid");
    var initialShippingTextContainer = bhAll("body.template-product .Product__Info .items .item .initial");
    var underPriceContainers = bhAll(".Product__Info div form .ProductMeta__Text");
    var underPriceContainerFree = underPriceContainers[0] || null;
    var underPriceContainerPaid = underPriceContainers[1] || null;

    document.addEventListener("variant:changed", function (event) {
      // BUG.md E5: ohne Guard warf jede nicht verfuegbare Variantenkombination hier
      // einen TypeError (event.detail bzw. event.detail.variant ist dann leer).
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      bhSetNodesVisible(initialShippingTextContainer, false);
      // Schwelle setzt main-product.liquid laenderabhaengig (4900 Pence UK / 5900 Cent IE),
      // damit dieser Umschalter dieselbe Grenze nutzt wie der gerenderte Initialtext.
      // Fallback = UK, das ist der UK-Shop.
      var freeShippingThreshold = window.BH_FREE_SHIPPING_THRESHOLD || 4900;
      if (variant.price >= freeShippingThreshold) {
        bhSetNodesVisible(freeShippingTextContainer, true); bhSetNodesVisible(paidShippingTextContainer, false);
        bhSetElementVisible(underPriceContainerFree, true); bhSetElementVisible(underPriceContainerPaid, false);
      } else {
        bhSetNodesVisible(freeShippingTextContainer, false); bhSetNodesVisible(paidShippingTextContainer, true);
        bhSetElementVisible(underPriceContainerFree, false); bhSetElementVisible(underPriceContainerPaid, true);
      }
    });

    // BUG.md E11: updateCartCount() feuerte /cart.js und verwarf die Antwort - drei
    // Bindings ohne jede Wirkung. Header-Zaehler und Warenkorb-Punkt aktualisiert
    // theme.js selbst in _replaceContent (Re-Render nach jeder Mengenaenderung).

    function waitForElm(selector) {
      return new Promise((resolve) => {
        if (document.querySelector(selector)) return resolve(document.querySelector(selector));
        const observer = new MutationObserver((mutations) => {
          if (document.querySelector(selector)) { resolve(document.querySelector(selector)); observer.disconnect(); }
        });
        observer.observe(document.body, { childList: true, subtree: true });
      });
    }
    waitForElm(".Product__Gallery .Image--lazyLoaded").then((elm) => {
      setTimeout(() => {
        const images = document.querySelectorAll(".Product__Gallery .Image--lazyLoaded");
        for (let i = 0; i < images.length; i++) { images[i].classList.add("Image--lazyLoad"); }
      }, 1);
    });

    document.addEventListener("click", function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== "function") return;
      if (!target.closest(".klaviyo-bis-trigger")) return;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "SVdrDW"]);
    });

  },
  false
);

// --------------------------------------------------------
// BUG.md E10: Hier lag 7,7 KB Testcode (Varianten-Bildfilter) fuer EIN einziges
// deutschsprachiges Produkt (/products/edelstahl-thermobehaelter-...), der an alle
// Besucher ausgeliefert wurde - inklusive vier console.logs und deutscher Debug-Texte.
// Ebenfalls entfernt (Nebenfund, gleiche Datei): der Block "5. DELIVERY TIME & VARIANT
// UTILS" - er suchte #variant-select / #delivery-time; beide IDs existieren im ganzen
// Theme nicht, der Code war toter Ballast mit deutschem Fallback-Text 'unbekannt'.
// --------------------------------------------------------

// -----------------------------------------------------------
// 🛡️ WÄCHTER
// -----------------------------------------------------------
(function() {
    var targetNode = document.querySelector('.ProductMeta__PriceList');
    if (!targetNode) return;

    var config = { childList: true, subtree: true, characterData: true };

    var observer = new MutationObserver(function(mutations, obs) {
        var state = window.CustomState;
        if (!state || !state.price) return;

        var shouldBeSale = (state.qty > 1) || (state.compare > state.price);

        if (shouldBeSale) {
            var badgeMissing = !document.getElementById("mengenrabatt-badge");
            var stattMissing = !document.getElementById("pricecontainermengenrabatt");

            // Check ob Streichpreis falsch gefärbt ist (Orange statt Grau)
            // Wir prüfen, ob der Streichpreis zufällig die Highlight-Farbe geerbt hat
            //
            // BUG.md E13 / S7 - Befund am Rand: #compareAtmengenrabatt wird nirgends im
            // Theme erzeugt (weder hier noch in src/theme.js, das die beiden anderen IDs
            // baut). Dieser Zweig kann heute nicht feuern. Er bleibt 1:1 stehen, weil ihn
            // zu entfernen eine Verhaltensentscheidung waere und nicht Teil von E13 ist.
            var stattEl = document.getElementById("compareAtmengenrabatt");
            var colorWrong = false;

            // Wenn der Streichpreis existiert, aber rot ist (oder die ID price-adjusted hat)
            if (stattEl) {
                // Prüfen ob falsche ID
                if(stattEl.getAttribute("id") === "price-adjusted") colorWrong = true;
                // Prüfen ob falsche Farbe im Style Attribut
                var style = stattEl.getAttribute("style") || "";
                if(style.indexOf("#f24a00") > -1) colorWrong = true;
            }

            if (badgeMissing || stattMissing || colorWrong) {
                 obs.disconnect();
                 if(typeof window.renderCustomUI === 'function') {
                     window.renderCustomUI();
                 }
                 obs.observe(targetNode, config);
            }
        }
    });
    observer.observe(targetNode, config);
})();

/**
 * Zubehoer und Sets im Warenkorb-Drawer (08.09.2026, ZIELPLAN-15K W4).
 *
 * Markup kommt aus snippets/cart-addons.liquid und wird bei jedem Re-Render des
 * Drawers (Section Rendering API, mini-cart) neu ausgeliefert. Deshalb kein Binding
 * an Elemente, sondern ein delegierter click-Listener auf document. Kein <form> im
 * Snippet: der Drawer-Inhalt steckt selbst in <form class="Cart">, ein verschachteltes
 * Formular wuerde vom Parser verworfen. Der Klick auf [data-addon-variant] schickt die
 * Variante per /cart/add.js und loest danach "cart:refresh" auf document.documentElement
 * aus (bubbles), worauf CartSection in theme.js den Drawer neu rendert (documentDelegate
 * "cart:refresh" -> _rerenderCart). Direkt auf document gefeuert kommt das Event dort nicht an.
 * Bewusst KEIN "product:added": dessen Listener erwarten ein Varianten-Objekt aus dem
 * Produktformular.
 *
 * Bekannte Grenze: add_to_cart im dataLayer feuert fuer diese Zusatzartikel nicht
 * (das tut nur der Produktformular-Pfad). Umsatz und Bestellung sind davon unberuehrt.
 */
document.addEventListener('click', function (event) {
  var button = event.target && event.target.closest ? event.target.closest('[data-addon-variant]') : null;
  if (!button) {
    return;
  }
  event.preventDefault();
  if (button.disabled) {
    return;
  }

  var variantId = button.getAttribute('data-addon-variant');
  if (!variantId) {
    return;
  }
  var buttonText = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding';

  var addUrl = (window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js';
  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  fetch(addUrl, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  }).then(function (response) {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    if (response.ok) {
      // Auf documentElement mit bubbles, wie layout/theme.liquid:448: der domDelegate-
      // Listener von CartSection sieht ein direkt auf document gefeuertes Event nicht
      // (gemessen 08.09.2026 im Browser: document -> kein Re-Render, documentElement -> Re-Render).
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return;
    }
    button.disabled = false;
    button.textContent = buttonText;
  }).catch(function () {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    button.disabled = false;
    button.textContent = buttonText;
  });
}, true);

/**
 * "What's in this set" auf Bundle-Seiten (08.09.2026): Groessen, Einzelpreise, Summe und
 * Ersparnis folgen der gewaehlten Variante. Die Preiskarte liegt als JSON im Modul
 * (snippets/set-contents.liquid, [data-set-map]); hier wird nur gelesen und geschrieben.
 * Kein eigenes Preisformat: dieselbe Symbol-Quelle wie renderCustomUI (CustomState.symbol).
 */
document.addEventListener('variant:changed', function (event) {
  var variant = event.detail && event.detail.variant;
  if (!variant) {
    return;
  }
  var root = document.querySelector('[data-set-contents]');
  if (!root) {
    return;
  }
  var mapEl = root.querySelector('[data-set-map]');
  if (!mapEl) {
    return;
  }
  var map;
  try {
    map = JSON.parse(mapEl.textContent);
  } catch (e) {
    return;
  }
  var row = map[String(variant.id)];
  if (!row) {
    return;
  }
  var symbol = (window.CustomState && window.CustomState.symbol) ? window.CustomState.symbol : '£';
  var fm = function (cents) { return symbol + (cents / 100).toFixed(2); };
  var set = function (selector, value) {
    var nodes = root.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = value;
    }
  };
  set('[data-set-size="1"]', row.o1);
  set('[data-set-size="2"]', row.o2);
  if (row.p1 > 0) { set('[data-set-single="1"]', fm(row.p1)); }
  if (row.p2 > 0) { set('[data-set-single="2"]', fm(row.p2)); }
  set('[data-set-compare]', fm(row.compare));
  set('[data-set-price]', fm(row.price));
  var saving = row.compare - row.price;
  if (saving > 0) {
    set('[data-set-saving]', fm(saving));
    set('[data-set-percent]', String(Math.round(saving * 100 / row.compare)));
  }
  var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 4900;
  set('[data-set-free]', row.price >= threshold ? 'This set ships free.' : (root.getAttribute('data-free-text') || ''));
});

/*
 * Mobile: Sticky-Kaufleiste, solange der Preis nicht im Bild ist (08.09.2026, Nils).
 * Zwei Wuensche vom selben Nachmittag: die Leiste soll oben beim Anschauen der Hauptbilder
 * da sein, und sie soll verschwinden, sobald der Preis zu sehen ist, weil sie ihn selbst
 * traegt und er sonst doppelt steht. sections/sticky-add-to-cart.liquid schaltet .show
 * nur am Kaufknopf (mehr als 480 px unter dem Viewport oder darueber); seit dem
 * Schlankmachen der Set-Seiten (Knopf bei 1 268 px, Viewport 812 px) trat das oben nie ein.
 * Bezugspunkt ist .ProductMeta__PriceList (snippets/product-meta.liquid), Rueckfall der
 * Kaufknopf. Drei Zustaende:
 *   bh-price-below    Preis liegt ganz unter dem sichtbaren Bereich (Leistenhoehe abgezogen,
 *                     denn die Leiste verdeckt die unteren ~128 px): custom.css zeigt die
 *                     Leiste unabhaengig von .show.
 *   bh-price-visible  Preis im Bild: custom.css versteckt die Leiste auch mit .show.
 *   bh-atc-gone       Preis weg UND der Kaufknopf selbst ist unter der Kopfzeile
 *                     (.StickyHeaderAnnouncmentWrapper, sticky) verschwunden: custom.css
 *                     zeigt die Leiste. Die Section beobachtet .ProductForm__BuyButtons,
 *                     also den ganzen Kaufblock samt "Pay in 30 days"-Zeilen, und ohne
 *                     Kopfzeilenhoehe; ihr .show kam deshalb erst, wenn auch die
 *                     Zahlungszeilen oben aus dem Bild waren (Nils, 08.09.2026 nachmittags).
 *   keine Klasse      Preis nach oben weg, Knopf noch (teilweise) im Bild: die Section
 *                     entscheidet allein, d. h. unsichtbar.
 * Bewusst KEIN IntersectionObserver: bei einem Sprung (Nach-oben-Link, wiederhergestellte
 * Scrollposition) durchquert das Element den Viewport nicht, der Observer feuert nicht und
 * die Klasse bliebe auf dem alten Stand (gemessen 08.09.2026, Sprung 1568 -> 0 px). Der
 * rAF-gedrosselte Scroll-Listener liest eine Rechteckposition je Frame; waehrend des
 * Scrollens ist das Layout ohnehin frisch, also ohne Reflow-Kosten.
 */
(function () {
  var ref = document.querySelector('.ProductMeta__PriceList') || document.querySelector('.ProductForm__AddToCart');
  if (!ref) {
    return;
  }
  var body = document.body;
  var sticky = document.getElementById('MobileStickyATC');
  var atc = document.querySelector('.ProductForm__AddToCart');
  var header = document.querySelector('.StickyHeaderAnnouncmentWrapper');
  var barHeight = 128;
  var pending = false;
  var update = function () {
    pending = false;
    if (sticky && sticky.offsetHeight > 0) {
      barHeight = sticky.offsetHeight;
    }
    var rect = ref.getBoundingClientRect();
    var visibleBottom = window.innerHeight - barHeight;
    var below = rect.top >= visibleBottom;
    var visible = !below && rect.bottom > 0;
    // Kopfzeile: nur wenn sie gerade oben klebt zaehlt ihre Unterkante als Sichtgrenze
    var headerBottom = 0;
    if (header) {
      var hr = header.getBoundingClientRect();
      if (hr.top <= 0 && hr.bottom > 0) {
        headerBottom = hr.bottom;
      }
    }
    var atcGone = false;
    if (atc) {
      var ar = atc.getBoundingClientRect();
      atcGone = ar.height > 0 && ar.bottom <= headerBottom;
    }
    body.classList.toggle('bh-price-below', below);
    body.classList.toggle('bh-price-visible', visible);
    body.classList.toggle('bh-atc-gone', !below && !visible && atcGone);
  };
  var schedule = function () {
    if (pending) {
      return;
    }
    pending = true;
    window.requestAnimationFrame(update);
  };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);
  window.addEventListener('pageshow', schedule);
  update();
})();
